import { render } from "./SortByButton.vue?vue&type=template&id=1477a989"
import script from "./SortByButton.vue?vue&type=script&lang=ts"
export * from "./SortByButton.vue?vue&type=script&lang=ts"
script.render = render

export default script